import report_pdfs from './extra_assets/json_maps/book-report-pdf.json'
export const rpt_pdfs = [... report_pdfs];